
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}><MDXTag name="p" components={components}>{`La montée des populistes de droite et de gauche représente le fait politique le plus marquant de notre époque. Leur logique est simple: il y a d’un côté le peuple, et de l’autre les élites.`}</MDXTag>
<MDXTag name="p" components={components}>{`Mais pourquoi ces mouvements ont-ils autant de succès? Et surtout, qui sont leurs partisans? La classe moyenne, notamment, est-elle en train de basculer?`}</MDXTag>
<MDXTag name="p" components={components}>{`Testez notre quiz interactif créé en collaboration avec le quotidien britannique «The Guardian». Le résultat vous fera découvrir où vous vous situez sur l’échelle du populisme. Vous pourrez aussi vous comparer aux hommes et femmes politiques de Suisse et d’ailleurs. Pour découvrir la méthodologie employée, `}<a href='#methodik'><i className='ui angle double down icon' />{`cliquez ici.`}</a></MDXTag>
           </MDXTag>
  }
}
MDXContent.isMDXComponent = true
  